import { IRestaurants, SortByTypes } from './types';
import { MutationTree } from 'vuex';
import { IRestaurantList } from './types';
import { IRestaurantCategory } from '@/shared/model/restaurant-category.model';

export const mutations: MutationTree<IRestaurants> = {
  retrieveRestaurants(state, restaurantsList: IRestaurantList[]): void {
    state.restaurants = restaurantsList;
  },

  retrieveRestaurantCategories(state, restaurantCategories: IRestaurantCategory[]): void {
    state.categories = restaurantCategories;
  },

  setSelectedCategory(state, newSelectedCategory: number): void {
    state.selectedCategory = newSelectedCategory;
  },

  setTypes_deliver(state, newDeliver: boolean): void {
    state.types.deliver = newDeliver;
  },
  setTypes_pickup(state, newPickup: boolean): void {
    state.types.pickup = newPickup;
  },

  setRatings(state, newRatings: number): void {
    state.ratings = newRatings;
  },

  setCosts_free(state, newFree: boolean): void {
    state.costs.free = newFree;
  },
  setCosts_all(state, newAll: boolean): void {
    state.costs.all = newAll;
  },

  setMinDeliveries_noPreference(state, newNoPreference: boolean): void {
    state.minDeliveries.noPreference = newNoPreference;
  },
  setMinDeliveries_all(state, newAll: boolean): void {
    state.minDeliveries.all = newAll;
  },

  setSortBy(state, newSortBy: SortByTypes): void {
    state.sortBy = newSortBy;
  },

  setSearch(state, newSearch: string): void {
    state.search = newSearch;
  },
};
